import React, { useEffect } from "react";
import FormComponent from "../components/FormComponent";
import Aos from "aos";
import 'aos/dist/aos.css'

function Banner() {
    useEffect(() => {
        Aos.init({
            once: true,
            duration: 500,
        });
    }, [])
    return (
        <>
            <section id="banner" className="position-relative banner_new">
                <div className="container-lg mx-3 mx-lg-auto position-relative custom_container">
                    <div className="row">
                        <div className="col-md-6 col-lg-7">
                            <div className="banner-text text-center">
                                <h1 data-aos="fade-up" data-aos-delay="100" data-aos-duration="800">Your Alumni <br className="d-block d-xl-none" /> Privileges Await.</h1>
                                <h4 data-aos="fade-up" data-aos-delay="200" data-aos-duration="800" className="only_desk">Seamless, rewarding perks crafted <br className="d-block d-xl-none" /> exclusively for alumni like you.</h4>
                                <div className="banner-bullets">
                                    <p><img src="dist/img/coupon.svg" className="icon_vouchers" alt="icon - Vouchers" width={35} height={35} data-aos="fade-up" data-aos-delay="300" data-aos-duration="800" /> <span data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">₹2,700* worth  <br className="d-block d-lg-none" /> Activation Vouchers.</span></p>
                                    {/* <p className="only_desk"><img src="dist/img/magic.svg" alt="icon - ishop"  width={35} height={35} data-aos="fade-up" data-aos-delay="400" data-aos-duration="800" /> <span data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">Incredible Rewards, <br className="d-block d-lg-none" /> Every Day via iShop.</span></p> */}
                                    <p><img src="dist/img/tickets.svg" alt="icon - tickets"  width={35} height={35} data-aos="fade-up" data-aos-delay="500" data-aos-duration="800" /> <span data-aos="fade-up" data-aos-delay="400" data-aos-duration="800">Up to ₹500* Movie <br className="d-block d-lg-none" /> Ticket Benefits.</span> </p>
                                    <img src="dist/img/img_no_feeNew.svg" alt="No Joining Fee, No Annual Fee" width={300} height={94}  data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000" className="img_no_fee" />
                                </div>
                                <img src="dist/img/lady.webp" alt="Image lady" width={476} height={675}  className="img-fluid banner_lady" data-aos="fade-in" data-aos-delay="0" data-aos-duration="800" />
                                <img src="dist/img/cards_mob.webp" width={511} height={299} alt="Card images - Coral, Rubyx, Sapphiro"   className="img-fluid cards d-block d-md-none" data-aos="fade-in" data-aos-delay="0" data-aos-duration="800" />
                                <img src="dist/img/cards.webp" width={777} height={235} alt="Card images - Coral, Rubyx, Sapphiro"  className="img-fluid cards d-none d-md-block" data-aos-offset="0" data-aos="fade-up" data-aos-delay="600" />

                            </div>
                        </div>

                        <div className="col-md-6 col-lg-5 position-relative">
                            <div className="form-section">
                                <FormComponent></FormComponent>
                            </div>
                        </div>
                    </div>

                    

                </div>
            </section>
        </>
    );
}

export default Banner;
